import React, { useState } from 'react';
import arrow from '../../assets/images/arrow_back.svg';
import Header from '../../assets/images/Header.svg';
import LicenseIcon from '../../assets/icons/Vector.svg';
import graduation from '../../assets/icons/graduation-cap-line.svg';
import suitcase from '../../assets/icons/suitcase-line.svg';
import first from '../../assets/icons/first-aid.svg';
import arrowgo from '../../assets/icons/arrowgo.svg';
import CustomINput from '../../components/common/InputField/InputField';
import CustomDatepicker from '../../components/common/datePicker/DatePicker';
import CustomDropDown from '../../components/common/dropdown/Dropdown';
import Icon from '../../assets/icons/info.svg';
import IconArrow from '../../assets/icons/Vector (1).svg';
import arrowleft from '../../assets/icons/arrow-left.svg';
import './PhysicianForm.css';
import PhoneInput from '../../components/common/phoneNumberInput/PhoneInput';
import SearchBar from '../../components/common/searchbar/SearchBar';
import Badges from '../../components/common/badges/Badges';
import DropZone from '../../components/common/dropzone/DropZone';

const DocumentUpload = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  handleClick,
  selectedTab,
  setFieldTouched,
  setTouched,
  validateForm,
  setFieldValue,
}) => {
  return (
    <div>
      <div
        className=" text-medium text-gray-500   rounded-lg w-full"
        id="profile"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <div className="flex items-center space-x-1 mb-4">
          <div className="pl-4">
            <img src={graduation} alt="License Icon" className="w-6 h-6" />
          </div>
          <h3 className="label-medium pt-2">Education Documents</h3>
        </div>
        <div className="border-t border-l">
          <div className=" pt-5 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
              <div>
                <DropZone
                  name="educationDocument"
                  onChange={(acceptedFiles) => {
                    // Update Formik state with accepted files

                    setFieldValue('educationDocument', acceptedFiles);
                  }}
                  value={values.educationDocument}
                />
                {errors.educationDocument && touched.educationDocument && (
                  <div className="text-red-500 text-[12px]">
                    {errors.educationDocument}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-1 mb-2 pt-8">
            <div className="pl-4">
              <img src={suitcase} alt="License Icon" className="w-6 h-6 " />
            </div>
            <h3 className="label-medium pt-2">Experience Documents</h3>
          </div>
          <hr />
          <div className="pt-4 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
              <div>
                <DropZone
                  name="experienceDocument"
                  onChange={(acceptedFiles) => {
                    // Update Formik state with accepted files

                    setFieldValue('experienceDocument', acceptedFiles);
                  }}
                  value={values.experienceDocument}
                />

                {errors.experienceDocument && touched.experienceDocument && (
                  <div className="text-red-500 text-[12px]">
                    {errors.experienceDocument}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-1 mb-2 pt-8">
            <div className="pl-4">
              <img src={first} alt="License Icon" className="w-6 h-6 " />
            </div>
            <h3 className="label-medium pt-2">
              Practitioner Specialties Documents
            </h3>
          </div>
          <hr />
          <div className=" pt-4 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
              <div>
                <DropZone
                  name="practitionerSpecialtiesDocuments"
                  onChange={(acceptedFiles) => {
                    // Update Formik state with accepted files

                    setFieldValue(
                      'practitionerSpecialtiesDocuments',
                      acceptedFiles
                    );
                  }}
                  value={values.practitionerSpecialtiesDocuments}
                />

                {errors.practitionerSpecialtiesDocuments &&
                  touched.practitionerSpecialtiesDocuments && (
                    <div className="text-red-500 text-[12px]">
                      {errors.practitionerSpecialtiesDocuments}
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div className="flex items-center space-x-1 mb-2 pt-8">
            <div className="pl-4">
              <img src={arrowgo} alt="License Icon" className="w-6 h-6 " />
            </div>
            <h3 className="label-medium pt-2">Request Attachments</h3>
          </div>
          <hr />
          <div className=" pt-4 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
              <div>
                <DropZone
                  name="requestAttachments"
                  onChange={(acceptedFiles) => {
                    // Update Formik state with accepted files

                    setFieldValue('requestAttachments', acceptedFiles);
                  }}
                  value={values.requestAttachments}
                />

                {errors.requestAttachments && touched.requestAttachments && (
                  <div className="text-red-500 text-[12px]">
                    {errors.requestAttachments}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end items-center pt-4">
          <div className="flex items-center justify-between w-[300px]">
            <button
              type="button"
              onClick={() => handleClick(3)}
              class="w-[128px] h-[40px] text-[#007A63] flex justify-center items-center  border border-[#007A63]  focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm  text-center  [#007A63] [#007A63] :text-white"
            >
              <img
                src={arrowleft}
                alt="logo"
                style={{ paddingRight: '12px' }}
              />
              Previous
            </button>
            <button
              type="button"
              onClick={() =>
                handleClick(5, validateForm, setTouched, setFieldTouched)
              }
              className="text-white bg-[#007A63] flex justify-center items-center  focus:ring-4 focus:outline-none w-[128px] h-[40px] font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
            >
              Next
              <img src={IconArrow} alt="logo" style={{ paddingLeft: '12px' }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentUpload;
